import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

const plans = [
  {
    name: 'Starter', price: '₹2,999', period: '/month', color: '#0066FF', bg: '#e8f0ff', popular: false,
    desc: 'Perfect for small businesses hiring occasionally',
    features: ['3 Active Job Posts', 'Basic Candidate Search', 'Email Support', 'Standard Listing Visibility', '30-day Job Validity', 'Application Management'],
    cta: 'Get Started',
  },
  {
    name: 'Professional', price: '₹7,999', period: '/month', color: '#fff', bg: '#0066FF', popular: true,
    desc: 'Best for growing companies with regular hiring needs',
    features: ['10 Active Job Posts', 'Advanced Candidate Search', 'Priority Support', 'Featured Listing Badge', '60-day Job Validity', 'Resume Database Access', 'Candidate Shortlisting', 'Analytics Dashboard'],
    cta: 'Start Free Trial',
  },
  {
    name: 'Enterprise', price: 'Custom', period: '', color: '#0A1628', bg: '#f8faff', popular: false,
    desc: 'For large organisations with high-volume hiring',
    features: ['Unlimited Job Posts', 'Full Candidate Database', 'Dedicated Account Manager', 'Premium Listing Placement', 'Custom Job Validity', 'API Integration', 'Bulk Resume Download', 'Advanced Analytics', 'White-label Options'],
    cta: 'Contact Sales',
  },
];

const solutions = [
  { icon: 'fa-bullseye',     color: '#0066FF', bg: '#e8f0ff', title: 'Targeted Job Posting',      desc: 'Reach the right candidates with smart targeting by skills, location, experience and category.' },
  { icon: 'fa-database',     color: '#00C896', bg: '#e6fff6', title: 'Resume Database Access',     desc: 'Search and filter through 120,000+ verified candidate profiles to find your perfect hire.' },
  { icon: 'fa-robot',        color: '#f59e0b', bg: '#fff8e6', title: 'AI-Powered Matching',        desc: 'Our algorithm automatically matches your job requirements with the most suitable candidates.' },
  { icon: 'fa-chart-bar',    color: '#8b5cf6', bg: '#f3eeff', title: 'Hiring Analytics',           desc: 'Track views, applications, shortlists and conversion rates with a real-time dashboard.' },
  { icon: 'fa-shield-alt',   color: '#ef4444', bg: '#fff0f0', title: 'Verified Candidates',        desc: 'Every candidate profile is verified — reducing time spent on unqualified applications.' },
  { icon: 'fa-headset',      color: '#06b6d4', bg: '#e0f9ff', title: 'Dedicated Support',          desc: 'Get a dedicated hiring consultant to help you find and close top talent faster.' },
];

const process = [
  { step: '01', icon: 'fa-edit',        color: '#0066FF', title: 'Post Your Job',         desc: 'Create a detailed job listing in minutes with our easy-to-use job posting tool.' },
  { step: '02', icon: 'fa-users',       color: '#00C896', title: 'Receive Applications',  desc: 'Qualified candidates apply directly. Review, filter and shortlist from your dashboard.' },
  { step: '03', icon: 'fa-comments',    color: '#f59e0b', title: 'Interview & Evaluate',  desc: 'Schedule interviews, share feedback and collaborate with your hiring team.' },
  { step: '04', icon: 'fa-handshake',   color: '#8b5cf6', title: 'Hire with Confidence',  desc: 'Make your offer and onboard your new hire — all tracked in one place.' },
];

const testimonials = [
  { name: 'Rajesh Kumar',   company: 'TechCorp India',    avatar: 'RK', color: '#0066FF', bg: '#e8f0ff', text: 'We hired 3 senior developers within 2 weeks. The quality of candidates on JustHiring24 is exceptional.' },
  { name: 'Meera Iyer',     company: 'DesignHub Pvt Ltd', avatar: 'MI', color: '#ec4899', bg: '#fdf0f7', text: 'The featured listing gave us 5x more visibility. Our time-to-hire dropped from 45 days to just 12.' },
  { name: 'Suresh Agarwal', company: 'FinanceFirst',      avatar: 'SA', color: '#f59e0b', bg: '#fff8e6', text: 'The resume database is a goldmine. We proactively reached out to candidates and filled roles faster.' },
];

export default function HiringSolutions() {
  const [activeTab, setActiveTab] = useState('solutions');

  return (
    <>
      <PageHeader title="Hiring Solutions" breadcrumb="Hiring Solutions" />

      {/* Hero */}
      <section style={{ background: 'linear-gradient(135deg, #0066FF 0%, #0044cc 100%)', padding: '70px 0' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48, alignItems: 'center' }} className="cat-stats-grid">
            <div>
              <span style={{ background: 'rgba(255,255,255,0.2)', color: '#fff', fontSize: 12, fontWeight: 700, padding: '6px 16px', borderRadius: 50, letterSpacing: 1 }}>FOR EMPLOYERS</span>
              <h2 style={{ color: '#fff', fontWeight: 800, fontSize: 38, margin: '16px 0 16px', lineHeight: 1.2 }}>Hire Smarter,<br />Hire Faster</h2>
              <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: 15, lineHeight: 1.8, marginBottom: 32 }}>
                End-to-end hiring solutions for businesses of all sizes. From job posting to final offer — we make recruitment effortless.
              </p>
              <div style={{ display: 'flex', gap: 12 }}>
                <Link to="/post-job" style={{ padding: '13px 28px', borderRadius: 12, background: '#fff', color: '#0066FF', fontWeight: 700, fontSize: 14, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                  <i className="fa fa-plus"></i> Post a Job Free
                </Link>
                <Link to="/browse-candidates" style={{ padding: '13px 28px', borderRadius: 12, background: 'rgba(255,255,255,0.15)', color: '#fff', fontWeight: 700, fontSize: 14, textDecoration: 'none', border: '1.5px solid rgba(255,255,255,0.3)', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                  <i className="fa fa-users"></i> Browse Candidates
                </Link>
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              {[
                { num: '120K+', label: 'Active Candidates', icon: 'fa-users' },
                { num: '48hrs', label: 'Avg. Time to Hire',  icon: 'fa-clock' },
                { num: '8K+',   label: 'Companies Trust Us', icon: 'fa-building' },
                { num: '95%',   label: 'Satisfaction Rate',  icon: 'fa-star' },
              ].map((s, i) => (
                <div key={i} style={{ background: 'rgba(255,255,255,0.12)', borderRadius: 16, padding: '20px', backdropFilter: 'blur(10px)', border: '1px solid rgba(255,255,255,0.2)' }}>
                  <i className={`fa ${s.icon}`} style={{ fontSize: 22, color: 'rgba(255,255,255,0.7)', marginBottom: 10, display: 'block' }}></i>
                  <div style={{ fontSize: 26, fontWeight: 800, color: '#fff' }}>{s.num}</div>
                  <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)', marginTop: 4 }}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Tab Nav */}
      <section style={{ background: '#fff', borderBottom: '1px solid #f0f0f0', padding: '0' }}>
        <div className="container">
          <div style={{ display: 'flex', gap: 0 }}>
            {[{ key: 'solutions', label: 'Our Solutions' }, { key: 'process', label: 'How It Works' }, { key: 'pricing', label: 'Pricing' }].map(t => (
              <button key={t.key} onClick={() => setActiveTab(t.key)}
                style={{ padding: '18px 28px', border: 'none', background: 'none', fontSize: 14, fontWeight: 600, cursor: 'pointer', color: activeTab === t.key ? '#0066FF' : '#888', borderBottom: activeTab === t.key ? '3px solid #0066FF' : '3px solid transparent', transition: 'all .2s' }}>
                {t.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Solutions Tab */}
      {activeTab === 'solutions' && (
        <section className="section-pad">
          <div className="container">
            <div className="section-header">
              <span className="section-badge">What We Offer</span>
              <h2 className="section-title">Complete Hiring Solutions</h2>
              <p className="section-sub">Everything you need to attract, evaluate and hire the best talent</p>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 24 }} className="cat-why-grid">
              {solutions.map((s, i) => (
                <div key={i} className="cat-why-card" style={{ background: '#fff', borderRadius: 20, padding: '28px 24px', border: '1.5px solid #eef0f8', boxShadow: '0 4px 20px rgba(0,0,0,0.04)', transition: 'all .25s' }}>
                  <div style={{ width: 58, height: 58, borderRadius: 16, background: s.bg, color: s.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, marginBottom: 18 }}>
                    <i className={`fa ${s.icon}`}></i>
                  </div>
                  <h5 style={{ fontSize: 16, fontWeight: 700, color: '#0A1628', marginBottom: 10 }}>{s.title}</h5>
                  <p style={{ fontSize: 13, color: '#888', lineHeight: 1.7, margin: 0 }}>{s.desc}</p>
                </div>
              ))}
            </div>

            {/* Testimonials */}
            <div style={{ marginTop: 60 }}>
              <h4 style={{ fontWeight: 700, color: '#0A1628', textAlign: 'center', marginBottom: 32 }}>What Employers Say</h4>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 24 }} className="cat-why-grid">
                {testimonials.map((t, i) => (
                  <div key={i} style={{ background: '#fff', borderRadius: 20, padding: '28px 24px', border: '1.5px solid #eef0f8', boxShadow: '0 4px 20px rgba(0,0,0,0.04)' }}>
                    <div style={{ display: 'flex', gap: 6, marginBottom: 16 }}>
                      {[...Array(5)].map((_, j) => <i key={j} className="fa fa-star" style={{ color: '#f59e0b', fontSize: 13 }}></i>)}
                    </div>
                    <p style={{ fontSize: 13, color: '#555', lineHeight: 1.7, marginBottom: 20, fontStyle: 'italic' }}>"{t.text}"</p>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                      <div style={{ width: 42, height: 42, borderRadius: '50%', background: t.bg, color: t.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 14 }}>{t.avatar}</div>
                      <div>
                        <div style={{ fontWeight: 700, fontSize: 14, color: '#0A1628' }}>{t.name}</div>
                        <div style={{ fontSize: 12, color: '#888' }}>{t.company}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Process Tab */}
      {activeTab === 'process' && (
        <section className="section-pad">
          <div className="container">
            <div className="section-header">
              <span className="section-badge">Simple Process</span>
              <h2 className="section-title">How It Works</h2>
              <p className="section-sub">Hire top talent in 4 simple steps</p>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 24, position: 'relative' }} className="cat-stats-grid">
              {process.map((p, i) => (
                <div key={i} style={{ background: '#fff', borderRadius: 20, padding: '32px 24px', border: '1.5px solid #eef0f8', boxShadow: '0 4px 20px rgba(0,0,0,0.04)', textAlign: 'center', position: 'relative' }}>
                  <div style={{ fontSize: 11, fontWeight: 800, color: p.color, letterSpacing: 2, marginBottom: 16 }}>STEP {p.step}</div>
                  <div style={{ width: 64, height: 64, borderRadius: '50%', background: p.color + '18', color: p.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 26, margin: '0 auto 20px' }}>
                    <i className={`fa ${p.icon}`}></i>
                  </div>
                  <h5 style={{ fontSize: 16, fontWeight: 700, color: '#0A1628', marginBottom: 10 }}>{p.title}</h5>
                  <p style={{ fontSize: 13, color: '#888', lineHeight: 1.7, margin: 0 }}>{p.desc}</p>
                </div>
              ))}
            </div>
            <div style={{ textAlign: 'center', marginTop: 48 }}>
              <Link to="/post-job" className="btn-grad px-5 py-3">Post Your First Job <i className="fa fa-arrow-right ms-2"></i></Link>
            </div>
          </div>
        </section>
      )}

      {/* Pricing Tab */}
      {activeTab === 'pricing' && (
        <section className="section-pad">
          <div className="container">
            <div className="section-header">
              <span className="section-badge">Transparent Pricing</span>
              <h2 className="section-title">Choose Your Plan</h2>
              <p className="section-sub">No hidden fees. Cancel anytime.</p>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 28, maxWidth: 960, margin: '0 auto' }} className="cat-why-grid">
              {plans.map((p, i) => (
                <div key={i} style={{ background: p.popular ? '#0066FF' : '#fff', borderRadius: 24, padding: '36px 28px', border: p.popular ? 'none' : '1.5px solid #eef0f8', boxShadow: p.popular ? '0 20px 60px rgba(0,102,255,0.35)' : '0 4px 20px rgba(0,0,0,0.04)', position: 'relative', transform: p.popular ? 'scale(1.04)' : 'scale(1)' }}>
                  {p.popular && <span style={{ position: 'absolute', top: -14, left: '50%', transform: 'translateX(-50%)', background: '#f59e0b', color: '#fff', fontSize: 11, fontWeight: 800, padding: '5px 18px', borderRadius: 50, whiteSpace: 'nowrap' }}>⭐ MOST POPULAR</span>}
                  <h4 style={{ fontSize: 20, fontWeight: 800, color: p.popular ? '#fff' : '#0A1628', marginBottom: 6 }}>{p.name}</h4>
                  <p style={{ fontSize: 13, color: p.popular ? 'rgba(255,255,255,0.7)' : '#888', marginBottom: 20 }}>{p.desc}</p>
                  <div style={{ marginBottom: 28 }}>
                    <span style={{ fontSize: 36, fontWeight: 800, color: p.popular ? '#fff' : '#0A1628' }}>{p.price}</span>
                    <span style={{ fontSize: 14, color: p.popular ? 'rgba(255,255,255,0.6)' : '#aaa' }}>{p.period}</span>
                  </div>
                  <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 28px' }}>
                    {p.features.map((f, j) => (
                      <li key={j} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, color: p.popular ? 'rgba(255,255,255,0.85)' : '#555', marginBottom: 10 }}>
                        <i className="fa fa-check-circle" style={{ color: p.popular ? '#7dd3fc' : '#00C896', flexShrink: 0 }}></i>
                        {f}
                      </li>
                    ))}
                  </ul>
                  <Link to={p.name === 'Enterprise' ? '/contact' : '/post-job'}
                    style={{ display: 'block', textAlign: 'center', padding: '13px', borderRadius: 12, fontWeight: 700, fontSize: 14, textDecoration: 'none', background: p.popular ? '#fff' : '#0066FF', color: p.popular ? '#0066FF' : '#fff', transition: 'all .2s' }}>
                    {p.cta} <i className="fa fa-arrow-right ms-2"></i>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-card">
            <div className="cta-left">
              <h2>Start Hiring Today</h2>
              <p>Post your first job free and reach 120,000+ qualified candidates.</p>
            </div>
            <div className="cta-right">
              <Link to="/post-job" className="cta-btn-white">Post a Job Free</Link>
              <Link to="/contact" className="cta-btn-outline">Talk to Sales</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
